// optional_inclusion — tick to include an optional block (with optional detail), saved on the appraisal.
import React, { useState } from 'react';
import { PlusSquare } from 'lucide-react';
import { StepCard, StepNav, ErrorLine, writeback } from './_stepKit';

export default function OptionalInclusion({ action, value, onChange, onNext, onBack, canBack, capturedData }) {
  const p = action.params || {};
  const [on, setOn] = useState(!!value?.included);
  const [detail, setDetail] = useState(value?.detail || '');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const out = { included: on, detail: on ? detail : '' };

  const next = async () => {
    setBusy(true); setErr('');
    try { await writeback(capturedData, 'optional_inclusions', out, p.content_ref || p.label); onChange(out); onNext(out); }
    catch (e) { setErr(e?.response?.data?.detail || e.message || 'Save failed'); } finally { setBusy(false); }
  };

  return (
    <div>
      <StepCard icon={PlusSquare} title={`Optional · ${p.label || 'Inclusion'}`} testid="wf-optional-inclusion">
        <label className="flex items-center gap-2 p-3 border border-slate-200 rounded cursor-pointer">
          <input type="checkbox" checked={on} onChange={(e) => setOn(e.target.checked)} data-testid="wf-optional-inclusion-input" />
          <span className="text-sm text-slate-700">Include {p.label || 'this'}</span>
        </label>
        {on && (
          <input value={detail} onChange={(e) => setDetail(e.target.value)} data-testid="wf-optional-inclusion-detail"
            className="w-full border border-slate-300 rounded px-3 py-2 text-sm" placeholder="Details shown to the client (optional)" />
        )}
        <ErrorLine err={err} testid="wf-optional-inclusion-err" />
      </StepCard>
      <StepNav canBack={canBack} onBack={onBack} onNext={next} busy={busy} />
    </div>
  );
}
